import { render, staticRenderFns } from "./pointAuctionEvent.vue?vue&type=template&id=34138086&scoped=true"
import script from "./pointAuctionEvent.vue?vue&type=script&lang=js"
export * from "./pointAuctionEvent.vue?vue&type=script&lang=js"
import style0 from "./pointAuctionEvent.vue?vue&type=style&index=0&id=34138086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34138086",
  null
  
)

export default component.exports